<template>
  <div class="panel-heading">
    <h3 class="panel-title text-overflow">{{ title }}</h3>
    <p class="description mt0 text-overflow" v-if="description" v-html="description"></p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "panel-heading",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    classExtra: {
      type: [Array, String],
      required: false
    },
    styleExtra: {
      type: String,
      required: false
    }
  }
};
</script>
<style scoped>
/* .panel-heading {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  } */
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Panel/PanelHeading.vue